import type { ReactNode } from 'react';

export type ProductIconName = 'desktop' | 'phone' | 'kitchen' | 'stock' | 'chart' | 'receipt' | 'check' | 'arrow' | 'play';

const paths: Record<ProductIconName, ReactNode> = {
  desktop: <><rect x="3" y="4" width="18" height="13" rx="2" /><path d="M8 21h8M12 17v4" /></>,
  phone: <><rect x="6" y="2" width="12" height="20" rx="2" /><path d="M10 5h4M11 19h2" /></>,
  kitchen: <><path d="M3 17h18M5 17v-3a7 7 0 0 1 14 0v3M12 7V4M10 4h4M3 21h18" /></>,
  stock: <><path d="m12 3 9 5v9l-9 5-9-5V8l9-5ZM3 8l9 5 9-5M12 13v9M7.5 5.5l9 5v4" /></>,
  chart: <><path d="M4 3v18h17M8 17v-5M13 17V8M18 17V4" /></>,
  receipt: <><path d="M5 3h14v18l-3-2-4 2-4-2-3 2V3ZM9 7h6M9 11h6M9 15h3" /></>,
  check: <path d="m5 12 4 4L19 6" />,
  arrow: <path d="M4 12h16m-6-6 6 6-6 6" />,
  play: <path d="m9 5 11 7-11 7V5Z" />,
};

export function ProductIcon({ name }: { name: ProductIconName }) {
  return <svg className="product-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{paths[name]}</svg>;
}
